import { useState, useReducer, useEffect } from "react";
import ExpenseForm from "./components/ExpenseForm/ExpenseForm";
import ExpenseInfo from "./components/ExpenseInfo/ExpenseInfo";
import ExpenseList from "./components/ExpenseList/ExpenseList";
import "./App.css";
import {
  collection,
  addDoc,
  deleteDoc,
  updateDoc,
  doc,
  onSnapshot,
} from "firebase/firestore";
import { db } from "./Firebase";

const reducer = (state, action) => {
  const { payload } = action;
  switch (action.type) {
    case "ADD_EXPENSE": {
      return {
        expenses: [payload.expense, ...state.expenses],
      };
    }
    case "REMOVE_EXPENSE": {
      return {
        expenses: state.expenses.filter((expense) => expense.id !== payload.id),
      };
    }
    //add logic for updating the expense here
    case "UPDATE_EXPENSE":
      return {
        expenses: state.expenses.map((expense) =>
          expense.id === payload.expense.id ? payload.expense : expense,
        ),
      };

    case "SET_EXPENSES":
      return {
        expenses: payload.expenses,
      };

    default:
      return state;
  }
};
// Use proper state management for populating the form in the expenseForm component on clicking the edit icon in the Transaction component
function App() {
  const [state, dispatch] = useReducer(reducer, { expenses: [] });
  const [editExpense, setEditExpense] = useState(null);

  //  REALTIME FETCH (on mount)
  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "expenses"), (snapshot) => {
      const expenses = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      dispatch({ type: "SET_EXPENSES", payload: { expenses } });
    });

    return () => unsubscribe(); // cleanup
  }, []);

  // Add exp //

  const addExpense = async (expense) => {
    try {
      await addDoc(collection(db, "expenses"), expense);
      // no dispatch needed (handled by onSnapshot)
    } catch (error) {
      console.error("Add Error:", error);
    }
  };

  // Delete exp //

  const deleteExpense = async (id) => {
    try {
     
      await deleteDoc(doc(db, "expenses", id));
      console.log("Deleted successfully");
      // no dispatch needed
    } catch (error) {
      console.error("Delete Error:", error);
    }
  };
  // Add  function for updation
  const updateExpense = async (expense) => {
    try {
      await updateDoc(doc(db, "expenses", expense.id), expense);
      setEditExpense(null);
      // no dispatch needed
    } catch (error) {
      console.error("Update Error:", error);
    }
  };

  const handleEdit = (expense) => {
    setEditExpense(expense);
  };
  return (
    <>
      <h2 className="mainHeading">Expense Tracker</h2>
      <div className="App">
        <ExpenseForm
          addExpense={addExpense}
          // Pass the props for populating the form with expense text and amount
          updateExpense={updateExpense}
          editExpense={editExpense}
        />
        <div className="expenseContainer">
          <ExpenseInfo expenses={state.expenses} />
          <ExpenseList
            expenses={state.expenses}
            deleteExpense={deleteExpense}
            handleEdit={handleEdit}
            // Pass props to update a transacation
          />
        </div>
      </div>
    </>
  );
}

export default App;
